export const CACHE_TIMES = {
  SHORT: 30000, // 30 seconds
  MEDIUM: 1800000, // 30 minutes
  LONG: 3600000, // 1 hour
};

export type CacheDuration = keyof typeof CACHE_TIMES;
